import { Component, Output, EventEmitter, Input } from '@angular/core';

@Component({
    selector: 'app-show-all',
    templateUrl: './show-all.component.html',
    styleUrls: ['./show-all.component.scss'],
    standalone: false
})
export class ShowAllComponent {

  @Input() numberOfElements: number;
  @Output() changed = new EventEmitter<any>();
  public showAll = false;

  constructor() { }

  public toggleShowAll(): void {
    this.showAll = !this.showAll;
    this.changed.emit(this.showAll);
  }

}
